import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { ButtonComponent } from '@shared/components/button';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { GeneralModalLayoutComponent } from '@shared/components/general-modal-layout/general-modal-layout.component';
import { ApplicationType } from '@shared/enums/application-type.enum';
import { ApplicationTypeSubmitDirective } from './application-type-submit.directive';
import { ApplicationTypeModalData } from './interfaces/application-type-modal-data.interfaces';
import { getOptionsFromEnum } from '@shared/utils';
import { CloseModalDirective } from '@shared/directives';
import { CcsSelectComponent } from '@shared/components';

@Component({
  selector: 'app-application-type-modal',
  imports: [
    ReactiveFormsModule,
    GeneralModalLayoutComponent,
    ButtonComponent,
    ApplicationTypeSubmitDirective,
    CloseModalDirective,
    CcsSelectComponent,
  ],
  templateUrl: './application-type-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationTypeModal {
  protected readonly dialogRef = inject<DialogRef>(DialogRef);
  protected readonly modalData: ApplicationTypeModalData = inject(DIALOG_DATA);

  private readonly _fb = inject(FormBuilder);

  protected readonly applicationTypeForm = this._fb.group({
    applicationType: new FormControl('', {
      validators: [Validators.required],
    }),
  });

  protected readonly applicationTypes = getOptionsFromEnum(ApplicationType);

  protected get portalSource() {
    return this.modalData.source;
  }
}
